<template>
  <div
    class="sttrancenter text-noselect"
    data-tst="trainer_ranges_center"
  >
    <!-- <div class="sttrancenter_item" v-if="hasFilterPills">
    </div> -->
    <div
      v-if="hasTableTile"
      class="sttrancenter_item position-relative"
    >
      <StudyTableTile
        class="stt_centered"
        :hSpot="hSpot"
        :gameformat="gameformat"
        :street="street"
        :mobile="mobile"
        :hasPlayers="hasTilePlayers"
        :hand="handInfo ? handInfo.hand : ''"
      />
      <div
        v-if="hasFilterPills && filterCombos.status !== 'inactive'"
        class="d-flex"
        style="
          position: absolute;
          z-index: 4;
          right: 0;
          height: 100%;
          width: 100%;
          background: var(--clr-black-1);
          top: 0;
        "
      >
        <StudyFiltersPills
          class="ml-auto my-auto"
          style="max-width: 100%; --clr-pills-back: var(--clr-black-1); height: 2.25rem"
          :alwaysVisible="false"
          :namespace="namespace"
          :street="street"
          :showBetsIn="showBetsIn"
          :filterCombos="filterCombos"
          :soltab="rangeTab"
          :hasFilterIntersection="true"
          tstPrefix="rangescenter_filterpills"
        />
      </div>
    </div>

    <div
      v-if="hasSimpleRangeItem"
      class="sttrancenter_item"
      :class="{
        sttrancenter_item_empty: !hasSimpleRange,
      }"
    >
      <div
        v-if="!hasSimpleRange && hasHideBtn"
        class="f-column"
      >
        <div
          v-if="viewStrategy"
          class="sttrancenter_item_title gw_hvr text_tab_small"
          @click="$emit('toggle', 'hasSimpleRangeHeroStrategy')"
        >
          {{ $t(`common.show_hero_strategy`) }}
          <HideShowBtn
            :value="hasSimpleRangeHeroStrategy"
            style="--hvr-content-opacity: 0.5"
            class="gw_hvr_content sttrancenter_item_eye"
          />
        </div>
        <div
          v-else
          class="sttrancenter_item_title gw_hvr text_tab_small"
          @click="
            () => {
              $emit('toggle', 'hasSimpleRangeHero')
              $emit('toggle', 'hasSimpleRangeOpponent')
            }
          "
        >
          {{ $t(`common.show_players_ranges`) }}
          <HideShowBtn
            :value="hasSimpleRange"
            style="--hvr-content-opacity: 0.5"
            class="gw_hvr_content sttrancenter_item_eye"
          />
        </div>
      </div>
      <TrainerRangesTables
        v-if="hasSimpleRange"
        :hasHeroStrategy="hasSimpleRangeHeroStrategy"
        :hasHero="hasSimpleRangeHero"
        :hasOpponent="hasSimpleRangeOpponent"
        :showPropHero="'range'"
        :showPropOpponent="'range'"
        :heroLeft="heroLeft"
        :tableGroups="tableGroups"
        :skeleton="skeletonOnly"
        :hero="hero"
        :opponent="opponent"
        :useHex="useHex"
        :handInfo="handInfo"
        :learningMode="learningMode"
        :hasExpandOverlay="hasExpandOverlay"
        :rangeKey="rangeKey"
        class="gw_hvr_top"
        style="--hvr-top-content-opacity: 0.5"
        :data-tst="`trainerRangesTables_${hasSimpleRangeHeroStrategy ? 'single' : 'multiple'}`"
        @table:click="$emit('table:click')"
        @table:mousedown="$emit('table:mousedown')"
        @opponent:click="$emit('toggle', 'hasSimpleRangeOpponent')"
        @hero:click="
          () => {
            if (viewStrategy) {
              $emit('toggle', 'hasSimpleRangeHeroStrategy')
              return
            }
            $emit('toggle', 'hasSimpleRangeHero')
          }
        "
      >
        <template #title_right_after>
          <StudyRangeHeightSwitcher
            v-if="hasRangeHeightSwitcher"
            :hasVerticalHorizontal="false"
            class="gw_hvr_top_content ml-1"
          />
        </template>
        <template
          v-if="hasHideBtn"
          #title_hero_after
        >
          <HideShowBtn
            v-if="viewStrategy"
            :value="hasSimpleRangeHeroStrategy"
            class="gw_hvr_content sttrancenter_item_eye"
            style="--hvr-content-opacity: 0.5"
            data-tst="showHide_trainerRangeTableHeroStrategy"
          />
          <HideShowBtn
            v-else
            :value="hasSimpleRangeHero"
            class="gw_hvr_content sttrancenter_item_eye"
            style="--hvr-content-opacity: 0.5"
            data-tst="showHide_trainerRangeTableHero"
          />
        </template>
        <template
          v-if="hasHideBtn"
          #title_opponent_after
        >
          <HideShowBtn
            :value="hasSimpleRangeOpponent"
            style="--hvr-content-opacity: 0.5"
            class="gw_hvr_content sttrancenter_item_eye"
            data-tst="showHide_trainerRangeTableOpponent"
          />
        </template>
      </TrainerRangesTables>
    </div>

    <div
      v-if="hasHorizontalChartItem"
      class="sttrancenter_item gw_hvr_top"
      style="--hvr-top-content-opacity: 0.5"
      :class="{
        sttrancenter_item_empty: !hasHorizontalChart,
      }"
    >
      <div
        v-if="hasHorizontalChartTitle"
        class="sttrancenter_item_title gw_hvr text_tab_small"
        data-tst="trainerHorizontalChart_title"
        @click="$emit('toggle', 'hasHorizontalChart')"
      >
        {{ $t(`common.actions`) }}

        <div
          class="d-flex align-center ml-auto"
          style="gap: 0.25rem"
        >
          <StudyGroupingSwitcherNew
            v-show="hasHorizontalChart"
            v-if="hasGroupingSwitcher"
            class="gw_hvr_top_content"
          />
          <HideShowBtn
            v-if="hasHideBtn"
            :value="hasHorizontalChart"
            style="--hvr-content-opacity: 0.5"
            class="gw_hvr_content sttrancenter_item_eye"
            data-tst="showHide_trainerHorizontalChart"
          />
        </div>
      </div>
      <HorizontalChart
        v-if="hasHorizontalChart"
        :legendRaiseFirst="true"
        :limitLegendTo="9"
        :grouping="grouping"
        :hasLegend="true"
        :freKey="freKey"
        :skeleton="skeletonOnly"
        :solution="solution_picked"
        :hasBreakdown="hasBreakdownInHorizontalChart"
        :useHex="useHex"
        :catDraws="catDraws"
        :catHands="catHands"
        :activeActions="filterActions"
        :readOnly="simpleView"
        :showBetsIn="showBetsIn"
        style="--legend-item-size: var(--horchart-legend-size)"
        @action:click="handleActionClick"
      />
    </div>
    <div
      v-if="hasHandStrengthItem"
      class="sttrancenter_item"
      :class="{
        sttrancenter_item_empty: !hasHandStrength,
      }"
    >
      <div
        class="sttrancenter_item_title gw_hvr_top text_tab_small"
        data-tst="trainerHandStrength_title"
        @click="$emit('toggle', 'hasHandStrength')"
      >
        <div
          class="gw_hvr f-center"
          style="--hvr-content-opacity: 0.5"
        >
          {{ $t(`trainer.trainer_hand_strength_title`) }}
          <div
            class="mdi mdi-help-circle-outline ml-1 mr-auto gw_hvr_content csst"
            @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
          >
            <div
              class="csst_content clr-white"
              style="position: fixed; max-width: clamp(12rem, 22rem, 96vw); width: 100vw"
              v-html="$t('trainer.trainer_hand_strength_title_tooltip')"
            ></div>
          </div>
        </div>
        <HideShowBtn
          v-if="hasHideBtn"
          :value="hasHandStrength"
          class="gw_hvr_top_content sttrancenter_item_eye"
          data-tst="showHide_trainerHandStrength"
          style="--hvr-top-content-opacity: 0.5"
        />
      </div>
      <TrainerHandStrength
        v-if="hasHandStrength"
        :isNA="!showFlopContent || invalidSolution"
        :skeleton="skeletonOnly"
        :handInfo="handInfo"
        data-tst="trainerHandStrength"
      />
    </div>

    <div
      v-if="hasRangeCategoriesItem"
      class="sttrancenter_item"
      :class="{
        sttrancenter_item_empty: !hasRangeCategories,
      }"
    >
      <div
        v-if="!hasRangeCategories && hasHideBtn"
        class="f-column"
        style="gap: var(--gap)"
      >
        <div
          class="sttrancenter_item_title gw_hvr text_tab_small"
          @click="$emit('toggle', 'hasRangeCategoriesHands')"
        >
          {{ $t(`common.hands`) }}
          <HideShowBtn
            style="--hvr-content-opacity: 0.5"
            :value="hasRangeCategoriesHands"
            class="gw_hvr_content sttrancenter_item_eye"
          />
        </div>
        <div
          class="sttrancenter_item_title gw_hvr text_tab_small"
          @click="$emit('toggle', 'hasRangeCategoriesDraws')"
        >
          {{ $t(`common.draws`) }}
          <HideShowBtn
            style="--hvr-content-opacity: 0.5"
            :value="hasRangeCategoriesDraws"
            class="gw_hvr_content sttrancenter_item_eye"
          />
        </div>
      </div>
      <TrainerRangeCategories
        v-if="hasRangeCategories"
        :skeleton="skeletonOnly"
        :hasHands="hasRangeCategoriesHands"
        :hasDraws="hasRangeCategoriesDraws"
        :catEqBuckets="catEqBuckets"
        :catEqBucketsAdvanced="catEqBucketsAdvanced"
        :hasEqBuckets="hasEqBuckets"
        :hasEqBucketsAdvanced="hasEqBucketsAdvanced"
        :hasHandsTitle="hasHandsTitle"
        :hasDrawsTitle="hasDrawsTitle"
        :hasEqBucketsTitle="hasEqBucketsTitle"
        :hasEqBucketsAdvancedTitle="hasEqBucketsAdvancedTitle"
        :catHands="catHands"
        :catDraws="catDraws"
        :hasArrowBtn="!simpleView"
        :useHex="useHex"
        :handInfo="handInfo"
        :readOnly="simpleView"
        :showFlopContent="showFlopContent"
        :filterCategories="filterCategories"
        style="
          --clr-tracactr-item-active: var(--tracactr-item-active);
          --clr-tracactr-item-inactive: var(--tracactr-item-inactive);
        "
        @cat:mouseenter="category => $store.dispatch('sol_detail_highlight', category)"
        @cat:mouseleave="() => $store.dispatch('sol_detail_highlight', null)"
        @cat:click="category => $store.dispatch('sol_filters_toggleCategory', { category })"
        @cat:arrowclick="
          categories => $store.dispatch('sol_filters_toggleCategories', { categories })
        "
      >
        <template #title_hands>
          <div
            class="sttrancenter_item_title gw_hvr text_tab_small"
            :class="{
              sttrancenter_item_empty: !hasRangeCategoriesHands,
            }"
            data-tst="trainerRangeCategoriesHands_title"
            @click="$emit('toggle', 'hasRangeCategoriesHands')"
          >
            {{ $t(`common.hands`) }}
            <div
              class="d-flex align-center ml-auto"
              style="gap: 0.25rem"
            >
              <StudyRangeLengthSwitcher
                v-show="hasRangeCategoriesHands"
                class="gw_hvr_top_content"
              />
              <HideShowBtn
                v-if="hasHideBtn"
                :value="hasRangeCategoriesHands"
                class="gw_hvr_content sttrancenter_item_eye"
                style="--hvr-content-opacity: 0.5"
                data-tst="showHide_trainerRangeCategoriesHands"
              />
            </div>
          </div>
        </template>
        <template #title_draws>
          <div
            class="sttrancenter_item_title gw_hvr text_tab_small"
            :class="{
              sttrancenter_item_empty: !hasRangeCategoriesDraws,
            }"
            data-tst="trainerRangeCategoriesDraws_title"
            @click="$emit('toggle', 'hasRangeCategoriesDraws')"
          >
            {{ $t(`common.draws`) }}
            <div
              class="d-flex align-center ml-auto"
              style="gap: 0.25rem"
            >
              <StudyRangeLengthSwitcher
                v-show="hasRangeCategoriesDraws"
                class="gw_hvr_top_content"
              />
              <HideShowBtn
                v-if="hasHideBtn"
                :value="hasRangeCategoriesDraws"
                style="--hvr-content-opacity: 0.5"
                class="gw_hvr_content sttrancenter_item_eye"
                data-tst="showHide_trainerRangeCategoriesDraws"
              />
            </div>
          </div>
        </template>
        <template #title_eq_buckets>
          <div
            class="sttrancenter_item_title gw_hvr text_tab_small f-center"
            @click="$emit('toggle', 'hasRangeCategoriesHands')"
          >
            {{ $t(`switchers.swv_eq_buckets_simple`) }}
            <div
              class="mdi mdi-help-circle-outline csst mr-auto gw_hvr_content ml-1"
              @mouseenter="e => fl_positionTooltip(e, { placement: 'top' })"
            >
              <div
                class="csst_content clr-white"
                style="position: fixed"
                v-html="$t(`browse.eq_buckets.eq_buckets_simple_tooltip`)"
              ></div>
            </div>

            <StudyRangeLengthSwitcher class="gw_hvr_top_content ml-1" />
          </div>
        </template>
        <template #title_eq_buckets_advanced>
          <div
            class="sttrancenter_item_title gw_hvr text_tab_small"
            @click="$emit('toggle', 'hasRangeCategoriesHands')"
          >
            {{ $t(`switchers.swv_eq_buckets_advanced`) }}
            <StudyRangeLengthSwitcher class="gw_hvr_top_content ml-1" />
          </div>
        </template>
      </TrainerRangeCategories>
    </div>

    <div
      v-if="hasEqChartItem"
      class="sttrancenter_item"
      :class="{
        sttrancenter_item_empty: !hasEqChart,
      }"
    >
      <div
        v-if="hasEqChartTitle"
        class="sttrancenter_item_title gw_hvr text_tab_small"
        data-tst="trainerEquityChart_title"
        @click="$emit('toggle', 'hasEqChart')"
      >
        {{ $t(`trainer.trainer_equity_chart_title`) }}
        <HideShowBtn
          v-if="hasHideBtn"
          style="--hvr-content-opacity: 0.5"
          :value="hasEqChart"
          class="gw_hvr_content sttrancenter_item_eye"
          data-tst="showHide_trainerEquityChart"
        />
      </div>
      <EquityChart
        v-if="hasEqChart"
        :skeleton="learningMode || skeletonOnly"
        :hands="combos"
        :hero="hero"
        :rangeKey="rangeKey"
        :opponent="opponent"
        :handsHero="filteredHeroHandsIds"
        :handsOpponent="filteredOpponentHandsIds"
        :handsActiveHero="heroHandsIds"
        :handsActiveOpponent="opponentHandsIds"
        :handsPinnedHero="handsPinnedHero"
        :player="player"
        :simpleView="simpleView"
        data-tst="trainerEquityChart"
        @click="$emit('eqchart:click')"
        @mousedown="$emit('eqchart:mousedown')"
      />
    </div>

    <div
      v-if="hasFilterSuitsItem"
      class="sttrancenter_item"
    >
      <StudyFilterSuits
        class="sttdfiltrs_suits"
        style="--mobile-display: grid"
      />
    </div>

    <div
      v-if="hasRangesComparisonItem"
      class="sttrancenter_item"
      :class="{
        sttrancenter_item_empty: !hasRangesComparison,
      }"
    >
      <div
        v-if="hasRangesComparisonTitle"
        class="sttrancenter_item_title gw_hvr text_tab_small"
        data-tst="trainerRangesComparison_title"
        @click="$emit('toggle', 'hasRangesComparison')"
      >
        {{ $t(`trainer.trainer_ranges_comparison_title`) }}
        <HideShowBtn
          v-if="hasHideBtn"
          :value="hasRangesComparison"
          style="--hvr-content-opacity: 0.5"
          class="gw_hvr_content sttrancenter_item_eye"
          data-tst="showHide_trainerRangesComparison"
        />
      </div>
      <TrainerRangesComparison
        v-if="hasRangesComparison"
        :flipped="!heroLeft"
        :catDraws="catDraws"
        :catEqBuckets="catEqBuckets"
        :catEqBucketsAdvanced="catEqBucketsAdvanced"
        :catHands="catHands"
        :filterCategories="filterCategories"
        :filterCombos="filterCombos"
        :handInfo="handInfo"
        :hasGuides="true"
        :hasTitlePlayers="hasRangesComparisonTitlePlayers"
        :playerLeft="playerLeft"
        :playerRight="playerRight"
        :playerLeftKey="playerLeftKey"
        :playerRightKey="playerRightKey"
        :isPreflop="l_isPreflop"
        :readOnly="simpleView"
        :showFlopContent="showFlopContent"
        :skeleton="skeletonOnly"
        class="sttranmain_ranges-comparison no-scroll-track"
        style="
          --clr-trrcmp-item-active: var(--tracactr-item-active);
          --clr-trrcmp-item-inactive: var(--tracactr-item-inactive);
        "
        @cat:mouseenter="category => $store.dispatch('sol_detail_highlight', category)"
        @cat:mouseleave="() => $store.dispatch('sol_detail_highlight', null)"
        @cat:click="ii => $store.dispatch('sol_filters_toggleCategory', { category: ii.category })"
      >
        <template #message>
          <MessagesGoPostflop
            v-if="!showFlopContent"
            :namespace="namespace"
            :canAISolve="canAISolve"
            :hasShortcutBtn="hasShortcutBtn"
            class="mt-4 gw_mesblock_container"
            style="
              --message-padding: 0.75rem;
              --clr-title: var(--clr-grey-2);
              --size-title: 0.875rem;
              --weight-title: 500;
              --btn-font-size: 0.7rem;
              --btn-margin: 0.5rem 0 0 0;
            "
            :title="$t(`messages.eq_buckets_preflop`)"
          />
        </template>
        <template #message_cat_empty="{ item }">
          <MessagesGoPostflop
            v-if="showFlopContent"
            :namespace="namespace"
            :canAISolve="canAISolve"
            :hasShortcutBtn="false"
            class="gw_mesblock_container"
            style="
              --message-padding: 0.75rem;
              --clr-title: var(--clr-grey-2);
              --size-title: 0.875rem;
              --weight-title: 500;
            "
            :title="
              $t(`messages.select_postflop_to_see_category`, {
                str: $t(`common.${item.id}`),
              })
            "
          />
        </template>
      </TrainerRangesComparison>
    </div>
  </div>
</template>

<script>
import StudyFilterSuits from '@/components/Study/StudyFilterSuits'
import HideShowBtn from '@/components/lib/HideShowBtn'
import StudyRangeLengthSwitcher from '@/components/Switchers/StudyRangeLengthSwitcher'
import StudyGroupingSwitcherNew from '@/components/Switchers/StudyGroupingSwitcherNew'
import HorizontalChart from '@/components/Charts/HorizontalChart/HorizontalChart'
import StudyRangeHeightSwitcher from '@/components/Switchers/StudyRangeHeightSwitcher'
import StudyFiltersPills from '@/components/Study/StudyFiltersPills'
import { toggleArrByKey } from '@/helpers/helpers'
import TrainerRangesTables from '@/components/Trainer/TrainerRangesTables'
import StudyTableTile from '@/components/Study/StudyTableTile'
import TrainerRangesComparison from '@/components/Trainer/TrainerRangesComparison'
import EquityChart from '@/components/Charts/LineCharts/EquityChart'
import TrainerRangeCategories from '@/components/Trainer/TrainerRangeCategories'
import MessagesGoPostflop from '@/components/Poker/Overlays/Messages/MessagesGoPostflop'
import TrainerHandStrength from '@/components/Trainer/TrainerHandStrength'

import float_mix from '@/mixins/float_mix'

export default {
  name: 'StudyRangesCenter',
  components: {
    TrainerHandStrength,
    TrainerRangesTables,
    MessagesGoPostflop,
    TrainerRangesComparison,
    EquityChart,
    StudyTableTile,
    TrainerRangeCategories,
    StudyFilterSuits,
    HideShowBtn,
    StudyRangeLengthSwitcher,
    StudyGroupingSwitcherNew,
    HorizontalChart,
    StudyRangeHeightSwitcher,
    StudyFiltersPills,
  },
  mixins: [float_mix],
  props: {
    namespace: { required: true, type: String },
    canAISolve: { required: true, type: Boolean },
    simpleView: Boolean,
    hasHorizontalChartItem: Boolean,
    hasHorizontalChartTitle: Boolean,
    hasHorizontalChart: Boolean,
    hasBreakdownInHorizontalChart: Boolean,

    hasRangeCategoriesItem: Boolean,
    hasRangeCategories: Boolean,
    hasRangeCategoriesHands: Boolean,
    hasRangeCategoriesDraws: Boolean,
    hasRangesComparisonItem: Boolean,
    hasRangesComparisonTitle: Boolean,
    hasRangesComparisonTitlePlayers: Boolean,
    hasRangesComparison: Boolean,
    hasEqChartItem: Boolean,
    hasEqChartTitle: Boolean,
    hasEqChart: Boolean,
    hasHandStrengthItem: Boolean,
    hasHandStrength: Boolean,

    hasHandsTitle: Boolean,
    hasDrawsTitle: Boolean,
    hasEqBucketsTitle: Boolean,
    hasEqBucketsAdvancedTitle: Boolean,

    hasFilterSuitsItem: Boolean,

    hasGroupingSwitcher: Boolean,
    hasRangeHeightSwitcher: Boolean,

    hasFilterPills: Boolean,
    rangeTab: String,

    hasTableTile: Boolean,
    hasTilePlayers: Boolean,
    invalidSolution: Boolean,
    skeletonOnly: Boolean,
    learningMode: Boolean,

    hasHideBtn: Boolean,
    viewStrategy: Boolean,
    hasSimpleRangeItem: Boolean,
    hasSimpleRange: Boolean,
    hasSimpleRangeHeroStrategy: Boolean,
    hasSimpleRangeHero: Boolean,
    hasSimpleRangeOpponent: Boolean,
    tableGroups: { default: () => [] },
    hasExpandOverlay: Boolean,

    hasShortcutBtn: Boolean,

    hasEqBuckets: Boolean,
    hasEqBucketsAdvanced: Boolean,
    isPreflop: Boolean,
    mobile: Boolean,
    heroLeft: Boolean,
    useHex: Boolean,
    grouping: String,
    hSpot: Object,
    handInfo: Object,
    showBetsIn: String,
    solution_picked: { default: () => [] },
    combos: { default: () => [] },
    street: String,
    hero: Object,
    opponent: Object,

    playerLeft: Object,
    playerRight: Object,
    playerLeftKey: { required: true, type: String },
    playerRightKey: { required: true, type: String },

    showFlopContent: { type: Boolean, required: true },
    catDraws: Array,
    catHands: Array,
    catEqBuckets: Array,
    catEqBucketsAdvanced: Array,
    heroHandsIds: { default: () => [] },
    opponentHandsIds: { default: () => [] },
    filteredHeroHandsIds: { default: () => [] },
    filteredOpponentHandsIds: { default: () => [] },
    filterActions: { default: () => [] },
    rangeKey: { default: () => 'range' },
    player: { default: () => '0' },
    handsPinnedHero: Array,
    freKey: { default: () => 'total_frequency' },
    filterCombos: Object,
    filterCategories: { default: () => [] },
    gameformat: Object,
  },
  emits: ['toggle', 'table:click', 'table:mousedown', 'eqchart:click', 'eqchart:mousedown'],
  data() {
    return {}
  },
  methods: {
    handleActionClick(action) {
      let res = this.filterCombos.actions
      res = toggleArrByKey({
        arr: res,
        items: action.actions,
        item: action,
        key: 'code',
      })
      this.$store.dispatch('sol_filters_apply', { key: 'actions', value: res })
    },
  },
  computed: {
    l_isPreflop() {
      return this.isPreflop || this.street === 'preflop'
    },
  },
}
</script>
<style lang="scss" scoped>
.sttrancenter {
  --horchart-legend-size: 1rem;
  --tracactr-item-active: var(--clr-white-0);
  --tracactr-item-inactive: var(--clr-white-0);
  --tracactr-last-item-padding: 0;

  --gap: 0.5rem;
  display: flex;
  min-height: 0;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: var(--gap);
  &_item {
    margin: 0rem 0 0.75rem 0;
    &_title {
      display: flex;
      justify-content: space-between;
      padding: 0 0 0.25rem 0;
    }
    &_empty {
      margin: 0;
      .sttrancenter_item_title {
        padding: 0;
      }
      .sttrancenter_item_eye {
        opacity: 1 !important;
      }
    }
    &:last-child {
      margin: 0;
      padding: var(--tracactr-last-item-padding);
    }
    &_eye {
      font-size: 1rem;
      margin-left: auto;
    }
  }
}
</style>
